module.exports = __webpack_public_path__ + "img/AramKakayFalah-AwKurayDuDliHaya.750c0148.jpg";